import { IBaseDataCard, ISiblingsData } from "components/CurrentNewTree/type"

export const getChildData = ({ firstName, dateBirth, lastName, rank, globalPos, pos, xPos, yPos, gender, middleName, isDead, dateOfDeath, isUnknown }: ISiblingsData) => {

    const data: IBaseDataCard = {
        type: "treeCard",
        userMaidenName: "s",
        gender,
        userIsDead: isDead,
        rank,
        globalPosition: globalPos,
        position: (pos),
        positionX: (pos === 'l' ? xPos : xPos),
        positionY: yPos + 100,
    }
    if (firstName) {
        data.userName = firstName
    }
    if (middleName) {
        data.userMiddleName = middleName
    }
    if (lastName) {
        data.userLastName = lastName
    }
    if (dateBirth) {
        data.userDataBirth = dateBirth
    } else {
        data.userDataBirth = '__.__.____'

    }
    if (isDead)
        if (dateOfDeath) {
            data.userDataDead = dateBirth

        } else {
            data.userDataDead = '__.__.____'

        }
    if (isUnknown) {
        data.type = "phantomNode"
    }
    return data
}